import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectComponent } from 'components/Project';
import { TabbedTemplatePage } from './TabbedTemplatePage';

export const TemplatePage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  if (true) {
    return (
      <TabbedTemplatePage
        id={Number(id || 0)}
        template={true}
        onLogoClick={() => navigate('/project_template')}
      />
    );
  } else {
    return (
      <ProjectComponent
        id={Number(id || 0)}
        template={true}
        onLogoClick={() => navigate('/project_template')}
      />
    );
  }
};
